import React from "react";
import "./Oursectors.css";
import { Helmet } from 'react-helmet';
const Oursectors = () => {

  return (
    <>
     <Helmet>
        <title>Our Sectors | GEMCO</title>
        <meta name="description" content="GEMCO delivers specialist MEP supply and installation services across the UAE, trusted on iconic projects for over 25 years including Wynn Al Marjan Island and the Museum of the Future." />
        <meta name="keywords" content="GEMCO UAE, specialist MEP contractor, MEP supply and installation, iconic UAE projects, Museum of the Future MEP, Wynn Al Marjan Island MEP, Dubai MEP company, commercial MEP services, HVAC electrical plumbing UAE, trusted MEP contractor UAE, large scale MEP projects." />
    </Helmet>
   <div className='wp_our_sector'>
      
      <div className="container wp_our_sector_section">
      
        <div className="our_sector_section_1">
          <h1>Our Sectors</h1>
        </div>
      
        <div className="our_sector_section_2">
          <p>With a rich history of contracting we are able to deliver in a diverse range of sectors that matches our expertise. To be a trusted, profitable
              , and innovative MEP & Civil contracting company, driven by people, technology, and sustainable growth.</p>
        </div>
      
      </div>

      <div className="container wp_four_section_of_sector">
        
        <div className="commercial">
          <div className="wp_commercial_image" alt="Shopping mall"></div>
          <h4 className='wp_commericial_text'>Commercial</h4>
        </div>

        <div className="residential">
          <div className="wp_residential_image" alt="High-rise residential tower in Dubai"></div>
          <h4 className='wp_commericial_text'>Residential</h4>
        </div>
        <div className="tourism">
          <div className="wp_tourism_image" alt="Luxury hotel exterior"></div>
          <h4 className='wp_commericial_text'>Hospitality & Leisure</h4>
        </div>
        <div className="justice">
          <div className="wp_justice_image" alt="Dubai Data center"></div>
          <h4 className='wp_commericial_text'>Industrial / data center</h4>
        </div>
        <div className="legacy">
          <div className="wp_legacy_image" alt="Mobility Pavilion"></div>
          <h4 className='wp_commericial_text'>Legacy projects</h4>
        </div>
      </div>
    </div>
    </>
  );
};

export default Oursectors;
